import { T } from '@/i18n/T';
import { Typography } from '@eye-able/ui';

const NoPreviewFallback = () => (
  <div className='eye:flex eye:h-full eye:w-full eye:items-center eye:justify-center eye:rounded-md eye:border eye:border-grey-100 eye:p-16'>
    <Typography
      variant='body-s'
      className='eye:text-center eye:wrap-break-word'
    >
      <T k='noPreview' />
    </Typography>
  </div>
);

export default NoPreviewFallback;
